/**
 * /tenants/$slug/security/frontline/badge-signin — the Badge
 * Sign-In offering page. Prefetches the near-primary surfaces
 * (posture, stations, groups) so the page renders warm. Prefetch
 * failures don't block the route; each surface renders its own
 * distinct error state (Promise.allSettled).
 */

import { createFileRoute } from "@tanstack/react-router";
import {
  fetchFrontlineConfig,
  fetchFrontlineGroups,
  fetchStations,
} from "@/features/frontline/queries";
import { BadgeSignInPage } from "@/features/frontline/pages/frontline-page";

export const Route = createFileRoute(
  "/_authed/tenants/$slug/security/frontline/badge-signin",
)({
  loader: async ({ context }) => {
    const id = context.tenant.id;
    await Promise.allSettled([
      context.queryClient.ensureQueryData({
        queryKey: ["admin", "frontline", id, "config"],
        queryFn: () => fetchFrontlineConfig(id),
      }),
      context.queryClient.ensureQueryData({
        queryKey: ["admin", "frontline", id, "stations"],
        queryFn: () => fetchStations(id),
      }),
      context.queryClient.ensureQueryData({
        queryKey: ["admin", "frontline", id, "groups"],
        queryFn: () => fetchFrontlineGroups(id),
      }),
    ]);
  },
  component: BadgeSignInPage,
});
